document.addEventListener('DOMContentLoaded', function () {

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mobile nav ---------- */
  var menuToggle = document.getElementById('mobileMenuToggle');
  var mobileNav = document.getElementById('mobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  /* ---------- scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    if ('IntersectionObserver' in window && !prefersReducedMotion) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { observer.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in-view'); });
    }
  }

  /* ---------- floating shop-now CTA ---------- */
  var hero = document.querySelector('.hero');
  if (hero) {
    var floatCta = document.createElement('a');
    floatCta.className = 'float-cta';
    floatCta.id = 'floatCta';
    floatCta.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/collections/all';
    floatCta.setAttribute('aria-label', 'Shop now');
    floatCta.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6h15l-1.5 9h-12z"/><path d="M6 6L5 3H2"/></svg> Shop now';
    document.body.appendChild(floatCta);

    window.addEventListener('scroll', function () {
      var trigger = hero.offsetTop + hero.offsetHeight;
      if (window.scrollY > trigger) {
        floatCta.classList.add('visible');
      } else {
        floatCta.classList.remove('visible');
      }
    }, { passive: true });
  }

  /* ---------- product gallery thumbnails ---------- */
  var mainImage = document.getElementById('mainImage');
  var thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      if (mainImage) mainImage.src = t.getAttribute('data-img');
    });
  });

  /* ---------- color swatch -> real hex mapping ---------- */
  var colorMap = {
    black: '#22221F', white: '#FFFFFF', blue: '#2E5C8A', navy: '#1F3A5C',
    pink: '#D98BA0', grey: '#9C9A92', gray: '#9C9A92', red: '#B23B3B',
    green: '#4F7A5C', yellow: '#D9B23B', orange: '#C1712E', purple: '#6B4E8A',
    brown: '#6B4E3D', beige: '#D8CBB0', silver: '#C7C7C2', gold: '#B8963C'
  };
  document.querySelectorAll('.swatch').forEach(function (s) {
    var val = (s.getAttribute('data-value') || '').toLowerCase().trim();
    if (colorMap[val]) s.style.background = colorMap[val];
  });

  /* ---------- variant picker (color swatches + dropdowns) ---------- */
  var variantSelect = document.querySelector('[data-variant-select]');
  var productForm = document.getElementById('product-form');

  function findMatchingVariant() {
    if (!variantSelect) return null;
    var selected = {};
    document.querySelectorAll('.swatch.active').forEach(function (s) {
      selected[s.getAttribute('data-option-position')] = s.getAttribute('data-value');
    });
    document.querySelectorAll('.option-select').forEach(function (sel) {
      selected[sel.getAttribute('data-option-position')] = sel.value;
    });

    var options = variantSelect.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var matches = true;
      Object.keys(selected).forEach(function (pos) {
        if (opt.getAttribute('data-option' + pos) !== selected[pos]) matches = false;
      });
      if (matches) return opt;
    }
    return null;
  }

  /* Stock status from real Shopify inventory (data-stock-qty is empty when the
     variant isn't tracked). Mirrors the Liquid in sections/main-product.liquid. */
  function updateStockNote(opt, available) {
    var note = document.querySelector('[data-stock-note]');
    if (!note) return;
    var raw = opt.getAttribute('data-stock-qty');
    var tracked = raw !== null && raw !== '';
    var qty = tracked ? parseInt(raw, 10) || 0 : null;
    var state = 'neutral', text = 'Available to order';
    if (!available) { state = 'out'; text = 'Out of stock'; }
    else if (tracked) {
      if (qty <= 0) { state = 'low'; text = 'Available on backorder'; }
      else if (qty <= 5) { state = 'out'; text = 'Only ' + qty + ' left — order soon'; }
      else if (qty <= 10) { state = 'low'; text = 'Low stock — limited units left'; }
      else { state = 'in'; text = 'In stock — ready to ship'; }
    }
    note.className = 'stock-note stock-note--' + state;
    var t = note.querySelector('[data-stock-text]');
    if (t) t.textContent = text; else note.textContent = text;
  }

  function applyVariant(opt) {
    if (!opt) return;
    if (productForm) {
      var idInput = productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
      if (idInput) idInput.value = opt.value;
    }
    var priceEls = document.querySelectorAll('[data-product-price]');
    var price = parseInt(opt.getAttribute('data-price'), 10);
    var comparePrice = parseInt(opt.getAttribute('data-compare-price'), 10);
    if (!isNaN(price) && window.asapFormatMoney) {
      priceEls.forEach(function (el) { el.textContent = window.asapFormatMoney(price); });
    }
    var compareEls = document.querySelectorAll('[data-product-compare-price]');
    if (comparePrice > price) {
      compareEls.forEach(function (el) {
        el.style.display = '';
        if (window.asapFormatMoney) el.textContent = window.asapFormatMoney(comparePrice);
      });
    } else {
      compareEls.forEach(function (el) { el.style.display = 'none'; });
    }
    var img = opt.getAttribute('data-image');
    if (img && mainImage) mainImage.src = img;

    var addBtns = document.querySelectorAll('[data-add-to-cart], [data-add-to-cart-mobile]');
    var available = opt.getAttribute('data-available') === 'true';
    addBtns.forEach(function (btn) {
      btn.disabled = !available;
      btn.classList.toggle('disabled', !available);
    });
    updateStockNote(opt, available);
    var discountEls = document.querySelectorAll('[data-product-discount]');
    discountEls.forEach(function (el) {
      if (comparePrice > price) { el.style.display = ''; el.textContent = 'Save ' + Math.round((comparePrice - price) * 100 / comparePrice) + '%'; }
      else { el.style.display = 'none'; }
    });
    // let the shared bundle selector recalculate for this exact variant
    document.dispatchEvent(new CustomEvent('asap:variant-change', { detail: { variantId: opt.value } }));
  }

  document.querySelectorAll('.swatch').forEach(function (s) {
    s.addEventListener('click', function () {
      var group = document.querySelectorAll('.swatch[data-option-position="' + s.getAttribute('data-option-position') + '"]');
      group.forEach(function (x) { x.classList.remove('active'); });
      s.classList.add('active');
      var label = document.querySelector('[data-option-value="' + s.getAttribute('data-option-position') + '"]');
      if (label) label.textContent = s.getAttribute('data-value');
      applyVariant(findMatchingVariant());
    });
  });
  document.querySelectorAll('.option-select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var label = document.querySelector('[data-option-value="' + sel.getAttribute('data-option-position') + '"]');
      if (label) label.textContent = sel.value;
      applyVariant(findMatchingVariant());
    });
  });

  /* ---------- accordions (Detailed Description, Specifications, etc.) ---------- */
  var accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');
  accordionTriggers.forEach(function (trigger) {
    var panel = trigger.parentElement.querySelector('[data-accordion-panel]');
    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) panel.classList.toggle('open', !isOpen);
    });
  });

  /* (quantity stepper, bundle selector, add-to-cart, buy-now and sticky bar now live in bundle-offer.js) */

  /* ---------- live cart: quantity + subtotal recalculation, no page reload ---------- */
  var cartItemsWrap = document.querySelector('[data-cart-items]');
  if (cartItemsWrap) {

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return (window.themeCurrencySymbol || 'R') + parts.join('.');
    }

    function updateCartUI(cart) {
      var countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function (el) { el.textContent = cart.item_count; });

      var badge = document.querySelector('.cart-count-badge');
      if (badge) badge.textContent = cart.item_count;

      var subtotalEls = document.querySelectorAll('[data-cart-subtotal]');
      subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });

      cart.items.forEach(function (item, i) {
        var row = document.querySelector('[data-cart-line="' + (i + 1) + '"]');
        if (!row) return;
        var lineTotalEl = row.querySelector('[data-cart-line-total]');
        if (lineTotalEl) lineTotalEl.textContent = formatMoney(item.final_line_price);
        var qtyInput = row.querySelector('[data-cart-qty-input]');
        if (qtyInput) qtyInput.value = item.quantity;
      });

      // remove rows for lines no longer present (e.g. quantity set to 0)
      var rows = document.querySelectorAll('[data-cart-line]');
      rows.forEach(function (row) {
        var idx = parseInt(row.getAttribute('data-cart-line'), 10);
        if (idx > cart.items.length) row.remove();
      });

      if (cart.item_count === 0) {
        var wrapper = document.querySelector('[data-cart-wrapper]');
        var emptyState = document.querySelector('[data-cart-empty-state]');
        if (wrapper) wrapper.style.display = 'none';
        if (emptyState) emptyState.style.display = '';
      }
    }

    function changeLine(line, quantity, row) {
      if (row) row.classList.add('updating');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartUI(cart);
          // free-gift lines follow the real cart: added/removed by eligibility, never duplicated
          if (window.AsapBundles) {
            // Reload so Shopify's real bundle discounts / gift line re-render for the new quantities.
            return window.AsapBundles.syncGifts(cart).then(function () { window.location.reload(); });
          }
        })
        .catch(function (err) {
          console.error('Cart update failed', err);
        })
        .finally(function () {
          if (row) row.classList.remove('updating');
        });
    }

    cartItemsWrap.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-cart-qty-minus]');
      var plusBtn = e.target.closest('[data-cart-qty-plus]');
      var removeBtn = e.target.closest('[data-cart-remove]');

      if (minusBtn || plusBtn) {
        var row = (minusBtn || plusBtn).closest('[data-cart-line]');
        var line = parseInt(row.getAttribute('data-cart-line'), 10);
        var input = row.querySelector('[data-cart-qty-input]');
        var newQty = parseInt(input.value, 10) || 1;
        newQty = minusBtn ? Math.max(0, newQty - 1) : newQty + 1;
        changeLine(line, newQty, row);
      }

      if (removeBtn) {
        e.preventDefault();
        var row2 = removeBtn.closest('[data-cart-line]');
        var line2 = parseInt(row2.getAttribute('data-cart-line'), 10);
        changeLine(line2, 0, row2);
      }
    });

    cartItemsWrap.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      var row = input.closest('[data-cart-line]');
      var line = parseInt(row.getAttribute('data-cart-line'), 10);
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(line, newQty, row);
    });
  }

  /* ---------- offer countdown: only rendered for a real offer end date ---------- */
  var countdown = document.querySelector('[data-offer-countdown]');
  if (countdown) {
    var endsAt = (parseInt(countdown.getAttribute('data-ends'), 10) || 0) * 1000;
    var cdText = countdown.querySelector('[data-countdown-text]');
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var tick = function () {
      var left = endsAt - Date.now();
      if (!endsAt || left <= 0) { countdown.hidden = true; clearInterval(timer); return; }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      cdText.textContent = d > 0 ? d + 'd ' + pad(h) + 'h ' + pad(m) + 'm' : pad(h) + 'h ' + pad(m) + 'm ' + pad(s % 60) + 's';
      countdown.hidden = false;
    };
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- product recommendations: fetch Shopify's native "related products" ---------- */
  var recSection = document.querySelector('[data-recommendations]');
  if (recSection) {
    var recUrl = recSection.getAttribute('data-url');
    fetch(recUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newContent = tmp.querySelector('[data-recommendations]');
        if (newContent && newContent.innerHTML.trim().length) {
          recSection.innerHTML = newContent.innerHTML;
        } else {
          recSection.style.display = 'none';
        }
      })
      .catch(function () {
        recSection.style.display = 'none';
      });
  }
});
